import React from "react";
interface PropertyContentDataProps {
  bank: string;
  state: string;
  city: string;
}
export default function PropertyContentData({
  bank,
  state,
  city,
}: PropertyContentDataProps) {
  return (
    <div className="text-xs px-[10px] font-sans text-brand-textBlack mt-0 mb-4">
      <div className="pt-5 pb-2 ">
        <dt className="text-sm font-semibold text-brand-textBlack">
          Property Details
        </dt>
      </div>
      <dl className={`divide-y "divide-gray-300" }`}>
        <div className="py-4 grid grid-cols-2 gap-2">
          <dt className="text-xs text-brand-textLightGrey">Bank</dt>
          <dd className="capitalize">{bank}</dd>
        </div>
        <div className="py-4 grid grid-cols-2 gap-2">
          <dt className="text-xs  text-brand-textLightGrey">State</dt>
          <dd className=" text-xs capitalize">{state}</dd>
        </div>
        <div className="py-4 grid grid-cols-2 gap-2">
          <dt className="text-xs  text-brand-textLightGrey">City</dt>
          <dd className=" text-xs capitalize"> {city}</dd>
        </div>
      </dl>
    </div>
  );
}
